import React from "react";
import "./Footer.css";
import "../CommonContainer/common.css"
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import footerlogo from "../../Assets/images/footer-logo.png"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container common-width-home-main-container">
        {/* Contact & Socials */}
        <div className="footer-column"> 
          <h4>Contact Us</h4>
          <p>+91 6304960489</p>
          <h4>Follow Us</h4>
           <div className="social-icons">
            <a
              href="https://www.instagram.com/sreerastu_silvers/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://wa.me/916304960489"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
          </div>
        </div>

        {/* Logo & Center Info */}
        <div className="footer-column footer-center">
          <img
            src={footerlogo}
            alt="Sreerasthu Silvers"
            className="footer-logo" 
          />
          <p>© 2025 Sreerasthu Silvers. All Rights Reserved.</p>
        </div>

        {/* Address */}
        <div className="footer-column final-content">
          <h4>Address</h4>
          <p>
            Sreerasthu Silvers,<br />
            Ramasomayajulu St,<br />
            Rama Rao Peta, Kakinada,<br />
             Andhra Pradesh 533001
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
